import { render, staticRenderFns } from "./SingleStoreBoard.vue?vue&type=template&id=0e9b5968&scoped=true&"
import script from "./SingleStoreBoard.vue?vue&type=script&lang=js&"
export * from "./SingleStoreBoard.vue?vue&type=script&lang=js&"
import style0 from "./SingleStoreBoard.vue?vue&type=style&index=0&id=0e9b5968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9b5968",
  null
  
)

export default component.exports